import { Component } from '@angular/core';
import { buttonStyles } from 'src/app/shared/btn/btn.component';
import { iconTypes } from 'src/app/shared/icon/icon.constants';
@Component({
  standalone: false,
  selector: 'app-contact-us-section',
  templateUrl: './contact-us-section.component.html',
  styleUrls: ['./contact-us-section.component.scss']
})
export class ContactUsSectionComponent {
  buttonStyles = buttonStyles;
  iconTypes = iconTypes;

  maxWidth = 977;

  
  constructor() {}
}
